import React, { useState } from 'react';
import AnimatedSection from '../components/AnimatedSection';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // WhatsApp numbers
  const whatsappNumbers = [
    { number: "9886631818", label: "Sales & Training Enquiry" },
    { number: "9986352227", label: "Support & General Enquiry" }
  ];

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    console.log('Contact form:', form);
    setSubmitted(true);
    setIsLoading(false);
    
    setTimeout(() => setSubmitted(false), 3000);
    setForm({ name: '', email: '', phone: '', message: '' });
  };

  // Function to generate WhatsApp link
  const getWhatsAppLink = (number, name) => {
    const message = `Hi! I'm ${name || 'interested'}. I would like to get more information about VTECH CODERS services.`;
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${number}?text=${encodedMessage}`;
  };

  // Google Review Link
  const googleReviewLink = "https://g.page/r/CZJ-aurXpW7SEBM/review";
  const googleMapsLink = "https://g.page/vtechcoders?share";

  // Correct Google Maps Embed URL for VTECH CODERS location
  const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3845.318876234567!2d75.0121416!3d15.4419083!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb8d39f06cd3f43%3A0xd5f9b56aea607e92!2sVTECH%20CODERS!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin";

  return (
    <>
      <section className="contact-section">
        {/* Animated Background */}
        <div className="animated-bg">
          <div className="gradient-bg-1"></div>
          <div className="gradient-bg-2"></div>
          <div className="gradient-bg-3"></div>
          <div className="floating-particles">
            {[...Array(40)].map((_, i) => (
              <div key={i} className="particle" style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 15}s`,
                animationDuration: `${8 + Math.random() * 12}s`,
                width: `${3 + Math.random() * 8}px`,
                height: `${3 + Math.random() * 8}px`
              }}></div>
            ))}
          </div>
        </div>

        <div className="container">
          <AnimatedSection animation="fade-up">
            <div className="section-header">
              <span className="section-subtitle">Get In Touch</span>
              <h2 className="section-title">Let's Connect</h2>
              <p className="section-description">
                Have a question or want to work with us? We'd love to hear from you!
              </p>
            </div>
          </AnimatedSection>
          
          <div className="contact-wrapper">
            {/* Contact Form */}
            <AnimatedSection animation="fade-left" delay={200}>
              <div className="contact-card form-card">
                <h3>Send us a Message</h3>
                {submitted && (
                  <div className="success-message">
                    <i className="fas fa-check-circle"></i>
                    <span>Message sent! We'll get back to you soon.</span>
                  </div>
                )}
                
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input 
                      type="text" 
                      name="name" 
                      placeholder="Full Name" 
                      value={form.name} 
                      onChange={handleChange} 
                      required 
                    />
                  </div>
                  
                  <div className="form-row">
                    <div className="form-group">
                      <input 
                        type="email" 
                        name="email" 
                        placeholder="Email Address" 
                        value={form.email} 
                        onChange={handleChange} 
                        required 
                      />
                    </div>
                    
                    <div className="form-group">
                      <input 
                        type="tel" 
                        name="phone" 
                        placeholder="Phone Number" 
                        value={form.phone} 
                        onChange={handleChange} 
                      />
                    </div>
                  </div>
                  
                  <div className="form-group">
                    <textarea 
                      name="message" 
                      rows="4" 
                      placeholder="Tell us about your project or training needs..." 
                      value={form.message} 
                      onChange={handleChange} 
                      required
                    ></textarea>
                  </div>
                  
                  <button type="submit" className="submit-btn" disabled={isLoading}>
                    {isLoading ? (
                      <><i className="fas fa-spinner spinner"></i> Sending...</>
                    ) : (
                      <><i className="fas fa-paper-plane"></i> Send Message</>
                    )}
                  </button>
                </form>
              </div>
            </AnimatedSection>

            {/* Contact Information */}
            <AnimatedSection animation="fade-right" delay={300}>
              <div className="contact-card info-card">
                <h3>Contact Information</h3>
                
                <div className="info-item">
                  <div className="info-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div className="info-content">
                    <h4>Visit Us</h4>
                    <p>4th Main Rd, opp. Suvarna Petrol Pump,<br />
                    Vivekananda Nagar, Rajatagiri,<br />
                    Dharwad, Karnataka 580004, India</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="info-content">
                    <h4>Email Us</h4>
                    <a href="mailto:info@vtechcoders.com">info@vtechcoders.com</a>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <i className="fab fa-whatsapp"></i>
                  </div>
                  <div className="info-content">
                    <h4>WhatsApp Enquiry</h4>
                    {whatsappNumbers.map((wa, idx) => (
                      <a 
                        key={idx}
                        href={getWhatsAppLink(wa.number, '')}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="whatsapp-link"
                      >
                        <i className="fab fa-whatsapp"></i> +{wa.number} - {wa.label}
                      </a>
                    ))}
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <i className="fas fa-phone-alt"></i>
                  </div>
                  <div className="info-content">
                    <h4>Call Us</h4>
                    <a href="tel:+919986352227">+91 99863 52227</a>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <div className="info-content">
                    <h4>Working Hours</h4>
                    <p>Monday - Saturday: 10:00 AM - 6:00 PM<br />
                    Sunday: Closed</p>
                  </div>
                </div>

                {/* Google Review Section */}
                <div className="review-section">
                  <h4>Share Your Experience</h4>
                  <div className="review-buttons">
                    <a 
                      href={googleReviewLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="review-btn google-review"
                    >
                      <i className="fab fa-google"></i>
                      <span>Write a Google Review</span>
                      <i className="fas fa-star"></i>
                    </a>
                    <a 
                      href={googleMapsLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="review-btn google-maps"
                    >
                      <i className="fas fa-map-marked-alt"></i>
                      <span>View on Google Maps</span>
                    </a>
                  </div>
                  <div className="rating-stars">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star-half-alt"></i>
                    <span className="rating-text">4.9 ★ (50+ reviews)</span>
                  </div>
                </div>

                {/* Quick WhatsApp Buttons */}
                <div className="quick-whatsapp">
                  <h4>Quick Connect</h4>
                  <div className="whatsapp-buttons">
                    {whatsappNumbers.map((wa, idx) => (
                      <a 
                        key={idx}
                        href={getWhatsAppLink(wa.number, '')}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="whatsapp-quick-btn"
                      >
                        <i className="fab fa-whatsapp"></i>
                        <span>{wa.label}</span>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </AnimatedSection>
          </div>

          {/* Google Map Section */}
          <AnimatedSection animation="fade-up" delay={400}>
            <div className="map-section">
              <h3>Find Us Here</h3>
              <div className="map-container">
                <iframe
                  src={mapEmbedUrl}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="VTECH CODERS Location"
                ></iframe>
              </div>
              <div className="map-address">
                <i className="fas fa-location-dot"></i>
                <span>4th Main Rd, opp. Suvarna Petrol Pump, Vivekananda Nagar, Rajatagiri, Dharwad, Karnataka 580004</span>
              </div>
              <div className="map-directions">
                <a 
                  href="https://www.google.com/maps/dir//VTECH+CODERS/@15.4419083,75.0121416,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bb8d39f06cd3f43:0xd5f9b56aea607e92!2m2!1d75.0147165!2d15.4419083"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="directions-btn"
                >
                  <i className="fas fa-directions"></i>
                  Get Directions
                </a>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>

      <style jsx>{`
        /* Main Section */
        .contact-section {
          padding: 5rem 0;
          position: relative;
          overflow: hidden;
          min-height: 100vh;
        }
        
        /* Animated Background */
        .animated-bg {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 0;
          overflow: hidden;
        }
        
        .gradient-bg-1,
        .gradient-bg-2,
        .gradient-bg-3 {
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
          animation: float 20s ease-in-out infinite;
        }
        
        .gradient-bg-1 {
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(59, 130, 246, 0.3), rgba(139, 92, 246, 0.2));
          top: -250px;
          left: -250px;
          animation-delay: 0s;
        }
        
        .gradient-bg-2 {
          width: 600px;
          height: 600px;
          background: radial-gradient(circle, rgba(139, 92, 246, 0.25), rgba(236, 72, 153, 0.15));
          bottom: -300px;
          right: -300px;
          animation-delay: -5s;
        }
        
        .gradient-bg-3 {
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(6, 182, 212, 0.2), rgba(59, 130, 246, 0.15));
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          animation-delay: -10s;
        }
        
        @keyframes float {
          0%, 100% {
            transform: translate(0, 0) scale(1);
          }
          33% {
            transform: translate(50px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-50px, 50px) scale(0.9);
          }
        }
        
        /* Floating Particles */
        .floating-particles {
          position: absolute;
          width: 100%;
          height: 100%;
        }
        
        .particle {
          position: absolute;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          border-radius: 50%;
          opacity: 0.2;
          animation: floatParticle linear infinite;
        }
        
        @keyframes floatParticle {
          0% {
            transform: translateY(100vh) rotate(0deg);
            opacity: 0;
          }
          10% {
            opacity: 0.3;
          }
          90% {
            opacity: 0.3;
          }
          100% {
            transform: translateY(-100vh) rotate(360deg);
            opacity: 0;
          }
        }
        
        /* Section Header */
        .section-header {
          text-align: center;
          margin-bottom: 3rem;
          position: relative;
          z-index: 2;
        }
        
        .section-subtitle {
          display: inline-block;
          font-size: 0.9rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 2px;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          margin-bottom: 1rem;
        }
        
        .section-title {
          font-size: 2.8rem;
          font-weight: 800;
          margin-bottom: 1rem;
          background: linear-gradient(135deg, #1e293b, #3b82f6);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        
        .section-description {
          color: #64748b;
          max-width: 600px;
          margin: 0 auto;
          font-size: 1.1rem;
        }
        
        /* Contact Wrapper */
        .contact-wrapper {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 2rem;
          margin-bottom: 3rem;
          position: relative;
          z-index: 2;
        }
        
        /* Contact Cards */
        .contact-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 24px;
          padding: 2rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(59, 130, 246, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .contact-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          border-color: rgba(59, 130, 246, 0.3);
        }
        
        .contact-card h3 {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          color: #1e293b;
          position: relative;
          display: inline-block;
        }
        
        .contact-card h3::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 50px;
          height: 3px;
          background: linear-gradient(95deg, #3b82f6, #8b5cf6);
          border-radius: 3px;
        }
        
        /* Form Styles */
        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }
        
        .form-group {
          margin-bottom: 1.2rem;
        }
        
        .form-group input,
        .form-group textarea {
          width: 100%;
          padding: 12px 16px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-family: inherit;
          transition: all 0.3s ease;
          font-size: 0.95rem;
          background: white;
        }
        
        .form-group input:focus,
        .form-group textarea:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          transform: translateY(-2px);
        }
        
        .submit-btn {
          width: 100%;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          color: white;
          border: none;
          padding: 12px;
          border-radius: 50px;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }
        
        .submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 20px rgba(59, 130, 246, 0.4);
        }
        
        .success-message {
          background: #dcfce7;
          padding: 12px;
          border-radius: 12px;
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
          gap: 10px;
          color: #166534;
          animation: slideDown 0.5s ease;
        }
        
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        /* Info Items */
        .info-item {
          display: flex;
          gap: 1rem;
          margin-bottom: 1.5rem;
          padding: 1rem;
          background: rgba(59, 130, 246, 0.05);
          border-radius: 16px;
          transition: all 0.3s ease;
        }
        
        .info-item:hover {
          background: rgba(59, 130, 246, 0.1);
          transform: translateX(5px);
        }
        
        .info-icon {
          width: 45px;
          height: 45px;
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(139, 92, 246, 0.2));
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        
        .info-icon i {
          font-size: 1.2rem;
          color: #3b82f6;
        }
        
        .info-content h4 {
          font-size: 0.9rem;
          font-weight: 600;
          color: #64748b;
          margin-bottom: 0.3rem;
        }
        
        .info-content p,
        .info-content a {
          color: #1e293b;
          text-decoration: none;
          line-height: 1.5;
          font-size: 0.95rem;
        }
        
        .info-content a:hover {
          color: #3b82f6;
        }
        
        .whatsapp-link {
          display: block;
          margin-bottom: 0.3rem;
          color: #25D366 !important;
        }
        
        .whatsapp-link i {
          margin-right: 5px;
        }
        
        /* Review Section */
        .review-section {
          margin: 1.5rem 0;
          padding: 1rem;
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.05), rgba(139, 92, 246, 0.05));
          border-radius: 16px;
          text-align: center;
        }
        
        .review-section h4 {
          font-size: 1rem;
          font-weight: 600;
          margin-bottom: 1rem;
          color: #1e293b;
        }
        
        .review-buttons {
          display: flex;
          gap: 1rem;
          margin-bottom: 1rem;
        }
        
        .review-btn {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 10px;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 600;
          font-size: 0.85rem;
          transition: all 0.3s ease;
        }
        
        .google-review {
          background: linear-gradient(135deg, #4285f4, #34a853);
          color: white;
        }
        
        .google-review:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(66, 133, 244, 0.4);
        }
        
        .google-maps {
          background: linear-gradient(135deg, #ea4335, #fbbc05);
          color: white;
        }
        
        .google-maps:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(234, 67, 53, 0.4);
        }
        
        .rating-stars {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          margin-top: 0.8rem;
        }
        
        .rating-stars i {
          color: #fbbf24;
          font-size: 0.9rem;
        }
        
        .rating-text {
          color: #64748b;
          font-size: 0.85rem;
          margin-left: 8px;
        }
        
        /* Quick WhatsApp Buttons */
        .quick-whatsapp {
          margin-top: 1rem;
          padding-top: 1rem;
          border-top: 1px solid #e2e8f0;
        }
        
        .quick-whatsapp h4 {
          font-size: 1rem;
          margin-bottom: 1rem;
          color: #1e293b;
        }
        
        .whatsapp-buttons {
          display: flex;
          gap: 1rem;
        }
        
        .whatsapp-quick-btn {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: linear-gradient(135deg, #25D366, #128C7E);
          color: white;
          padding: 10px;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 600;
          font-size: 0.85rem;
          transition: all 0.3s ease;
        }
        
        .whatsapp-quick-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(37, 211, 102, 0.4);
        }
        
        /* Map Section */
        .map-section {
          position: relative;
          z-index: 2;
          margin-top: 2rem;
        }
        
        .map-section h3 {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          text-align: center;
          color: #1e293b;
        }
        
        .map-container {
          width: 100%;
          height: 400px;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(59, 130, 246, 0.2);
          transition: transform 0.3s ease;
        }
        
        .map-container:hover {
          transform: scale(1.01);
        }
        
        .map-address {
          margin-top: 1rem;
          text-align: center;
          padding: 1rem;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          color: #1e293b;
          font-size: 0.9rem;
        }
        
        .map-address i {
          color: #ef4444;
          font-size: 1.2rem;
        }
        
        .map-directions {
          text-align: center;
          margin-top: 1rem;
        }
        
        .directions-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          color: white;
          padding: 12px 24px;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 600;
          transition: all 0.3s ease;
        }
        
        .directions-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(59, 130, 246, 0.4);
        }
        
        /* Responsive */
        @media (max-width: 968px) {
          .contact-wrapper {
            grid-template-columns: 1fr;
          }
          
          .section-title {
            font-size: 2rem;
          }
          
          .form-row {
            grid-template-columns: 1fr;
            gap: 0;
          }
          
          .review-buttons {
            flex-direction: column;
          }
        }
        
        @media (max-width: 768px) {
          .contact-section {
            padding: 3rem 0;
          }
          
          .contact-card {
            padding: 1.5rem;
          }
          
          .whatsapp-buttons {
            flex-direction: column;
          }
          
          .map-container {
            height: 300px;
          }
        }
        
        /* Dark Mode */
        @media (prefers-color-scheme: dark) {
          .contact-card {
            background: rgba(30, 41, 59, 0.95);
          }
          
          .contact-card h3 {
            color: #f1f5f9;
          }
          
          .form-group input,
          .form-group textarea {
            background: #1e293b;
            border-color: #334155;
            color: #f1f5f9;
          }
          
          .info-content p,
          .info-content a {
            color: #cbd5e1;
          }
          
          .review-section h4,
          .quick-whatsapp h4 {
            color: #f1f5f9;
          }
          
          .map-address {
            background: rgba(30, 41, 59, 0.9);
            color: #cbd5e1;
          }
          
          .rating-text {
            color: #94a3b8;
          }
        }
        
        .spinner {
          animation: spin 1s linear infinite;
        }
        
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
};

export default Contact;